interface IRetryWithDelayParams {
  asyncFn: () => Promise<void> | undefined;
  onError: (error: Error) => void;
  retryCount: number;
  delay?: number;
  errorText?: string;
}

export async function retryWithDelay({
  asyncFn,
  onError,
  retryCount,
  delay = 1000,
  errorText = 'Исчерпано количество попыток запроса',
}: IRetryWithDelayParams) {
  for (let i = 0; i < retryCount; i++) {
    try {
      const result = await asyncFn();

      return result;
    } catch (error) {
      onError(error);

      await new Promise(resolve => setTimeout(resolve, (i + 1) * delay));
    }
  }

  throw new Error(errorText);
}
